<template>
  <div class="chapter-view" @click="hideChapterView()" v-if="!isPreview()">
    <h1 class="chapter-view__text" v-html="htmlText"></h1>
  </div>
</template>

<script>
export default {
  name: "ChapterView",
  props: {
    htmlText: String
  },
  methods: {
    hideChapterView() {
      this.$store.dispatch("hideChapterView", {
        chatId: this.$route.params.id,
      });
    },
    isPreview() {
      const mode = this.$store.getters.getMode;
      return mode && mode === 'preview';
    }
  }
};
</script>

<style lang="scss">
.chapter-view {
  background-color: #0085ff;
  position: fixed;
  z-index: 9999;
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;

  &__text {
    color: $txt-color-alt;
    margin-top: 10%;
    text-align: center;
    font-weight: 400;
    line-height: 1.3;
    font-size: 32px;
    padding: 0 30px;
    width: 100%;
    left: 50%;
    top: 50%;

    p {
      text-transform: uppercase;
      font-weight: bold;
    }

    span {
      font-size: 16px;
    }

    a {
      p {
        font-weight: normal;
        text-decoration: underline;
      }

      span {
        font-size: 14px;
      }
    }
  }
}
</style>
